export const ROOT = 'common/account';

export const ACTIVE_ACCOUNT_REQUEST = `${ROOT}/ACTIVE_ACCOUNT_REQUEST`;
export const ACTIVE_ACCOUNT_FAILURE = `${ROOT}/ACTIVE_ACCOUNT_FAILURE`;
export const ACTIVE_ACCOUNT_SUCCESS = `${ROOT}/ACTIVE_ACCOUNT_SUCCESS`;
